<template>
  <div>
    <canvas
      :id="id"
      width="400"
      height="400"
      style="max-height: 500px"
    ></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";

export default {
  props: {
    chartType: { type: String, default: "" },
    chartData: { type: Object, default: null },
    chartOptions: { type: Object, default: null },
    chartText: { type: String, default: "" },
    id: { type: String, default: "doughnutChart" },
  },
  mounted() {
    //let { chartType, chartData, chartOptions } = this;
    this.chartConstructor(this.chartType, this.chartData, this.chartOptions);
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: function (newData) {
      this.chart.data.datasets.datasets = newData;
      this.chart.update();
      this.chartConstructor(this.chartType, this.chartData, this.chartOptions);
    },
  },
  methods: {
    chartConstructor(chartType, chartData, chartOptions) {
      const chartElement = document.getElementById(this.id);

      this.chart = new Chart(chartElement, {
        type: chartType,
        data: chartData,
        options: chartOptions,
      });

      // this.chart.update();
    },
    updateChart() {
      this.chartConstructor(this.chartType, this.chartData, this.chartOptions);
    },
    destroyChart() {
      this.chart.destroy();
    },
  },
};
</script>
